import PopNotificationCard from './PopNotificationCard.component';

export default PopNotificationCard;